import type { CSSProperties } from 'react'
import type { Cover as CoverModel } from '../../lib/recipeBook'

// The generated cover (feature spec 02): a recipe is drawn from what it's made
// of — its biggest category's tint, its initial cropped large, and one segment
// per ingredient in category colour. Optionally the time. A recipe with a
// photo (035, the recipe editor) shows it in place of the initial, the
// segments still along its foot. The square (the Recipes grid) carries the
// time as a pill and no segments.
export function Cover({ cover, tintFor, minutes, size = 'card', photoUrl }: {
  cover: CoverModel
  tintFor: (categoryId: string | null) => string
  minutes?: number | null
  size?: 'card' | 'tile' | 'mini' | 'thumb' | 'square'
  /** A signed URL of the recipe's photo (useRecipePhotos); none = the generated cover. */
  photoUrl?: string | null
}) {
  return (
    <div className={`ml-cover ml-cover--${size}${photoUrl ? ' has-photo' : ''}`} aria-hidden="true"
      style={{ '--ml-tint': tintFor(cover.categoryId) } as CSSProperties}>
      {photoUrl
        ? <img className="ml-cover__photo" src={photoUrl} alt="" loading="lazy" decoding="async" />
        : <span className="ml-cover__initial">{cover.initial}</span>}
      {size === 'card' && minutes != null && (
        <span className="ml-cover__time"><span className="ml-cover__min ml-num">{minutes}</span><span className="ml-label">min</span></span>
      )}
      {size === 'square' && minutes != null && <span className="ml-cover__pill ml-num">{minutes} min</span>}
      {(size === 'card' || size === 'tile') && (
        <span className="ml-cover__bar">
          {cover.segments.map((id, i) => (
            <span key={i} className="ml-cover__seg" style={{ background: tintFor(id) }} />
          ))}
        </span>
      )}
    </div>
  )
}
